<!-- @format -->

<div class="row page-content">
	<div class="col-12 col-lg-8 col-xl-9 spot">
		<span *ngIf="homrContent['Spot 1'] && homrContent['Spot 1'][0]">
			<a
				*ngIf="homrContent['Spot 1'][0].link && homrContent['Spot 1'][0].link !== 'na'"
				[href]="homrContent['Spot 1'][0].link"
				[attr.data-em]="
					createTag(
						'1',
						homrContent['Spot 1'][0].headline,
						homrContent['Spot 1'][0].Subhead
					)
				"
				class="marketing-content-1">
				<clp-main-marketing-content
					[spotNumber]="'1'"
					[data]="homrContent['Spot 1'][0]">
				</clp-main-marketing-content>
			</a>
			<span
				*ngIf="
					homrContent['Spot 1'][0] !== undefined &&
					homrContent['Spot 1'][0].link &&
					homrContent['Spot 1'][0].link === 'na'
				"
				class="marketing-content-1">
				<clp-main-marketing-content
					[data]="homrContent['Spot 1'][0]"></clp-main-marketing-content>
			</span>
		</span>
	</div>
	<div class="col-12 col-lg-4 col-xl-3 content">
		<div class="title-container">
			<clp-breadcrumb
				*ngIf="
					categoryData &&
					categoryData.breadCrumbDetails &&
					categoryData.breadCrumbDetails.length > 0
				"
				[breadcrumbs]="categoryData.breadCrumbDetails"
				[title]="
					categoryData.note ? categoryData.note : categoryData.name
				"></clp-breadcrumb>
			<h1>{{ categoryData.name }}</h1>
		</div>
		<clp-promotion-banner
			*ngIf="homrContent['Promotional Banner']"
			class="hmf-py-xs hmf-px-m"
			[promotion]="homrContent['Promotional Banner'][0]"></clp-promotion-banner>
		<ng-container *ngIf="isMobile; then mobileAccordian; else largeAccordian"></ng-container>
		<ng-template #mobileAccordian>
			<div class="cats">
				<div
					*ngFor="let panel of categoryData.childVOs; index as i; trackBy: trackByFn"
					[ngClass]="{ family: panel.pageType !== 'c' }">
					<mat-expansion-panel
						#mep="matExpansionPanel"
						*ngIf="panel.pageType === 'c'"
						[expanded]="panel.panelOpenState"
						(opened)="panel.panelOpenState = true"
						(closed)="panel.panelOpenState = false">
						<mat-expansion-panel-header (click)="categoryClick($event, i)">
							<mat-panel-title
								[attr.data-em]="panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′'"
								[attr.title]="panel.note ? panel.note : panel.name">
								<span>
									<!-- For LCP purpose when is mobile we will prioritize the first 3 images only. That is why "i" has an addition of 2 -->
									<shared-media-component-media
										*ngIf="panel.fullImage || panel.visualAssets"
										[visualAssets]="panel.visualAssets"
										[image]="panel.fullImage"
										[itemTitle]="panel.note ? panel.note : panel.name"
										[altText]="''"
										[willLazyLoad]="true"
										[imagePagePosition]="i+mobileImageAddition">
									</shared-media-component-media>
								</span>
								<strong *ngIf="panel.note"> {{ panel.note }}</strong>
								<strong *ngIf="!panel.note"> {{ panel.name }}</strong>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<p class="category-count">
								{{ panel?.childVOs?.length }}
								<span *ngIf="panel?.childVOs?.length > 1">Categories</span
								><span *ngIf="panel?.childVOs?.length === 1">Category</span>
							</p>
							<div class="row accordian-data">
								<div
									*ngFor="let cat of panel.childVOs; trackBy: trackByFn"
									class="col-4 col-md-2 col-lg-3">
									<a
										[href]="cat.url"
										[attr.data-em]="
											cat.em | dcsgStripSpecialChars: '\ |\&|\'|\′'
										"
										[attr.title]="cat.note ? cat.note : cat.name">
										<span>
											<!-- For LCP purposes: Images are forced to be lazy loaded (imagePagePosition=5)
											 	because they're located inside the expansion panel, and they are not needed in the initial viewport -->
											<shared-media-component-media
												*ngIf="cat.fullImage || cat.visualAssets"
												[visualAssets]="cat.visualAssets"
												[image]="cat.fullImage"
												[itemTitle]="cat.note ? cat.note : cat.name"
												[altText]="''"
												[willLazyLoad]="true"
												[imagePagePosition]="lazyImagePosition">
											</shared-media-component-media>
										</span>
										<p [innerHtml]="cat.note ? cat.note : cat.name"></p>
									</a>
								</div>
							</div>
							<div class="view-all-container row">
								<div class="col-6">
									<a
										[href]="panel.url"
										attr.data-em="{{
											panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′'
										}}_ViewAllCategories"
										[attr.title]="panel.note ? panel.note : panel.name"
										>View Category Page</a
									>
								</div>
								<div
									class="col-6"
									(click)="mep.expanded = !mep.expanded">
									<span>Close</span>
									<homefield-icon name="chevron-up"></homefield-icon>
								</div>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<a
						[href]="panel.url"
						class="category-link"
						*ngIf="panel.pageType !== 'c'"
						[attr.data-em]="panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′'"
						[attr.attributes.title]="panel.note ? panel.note : panel.name">
						<span>
							<div
								*ngIf="panel.targetImage"
								class="image-box">
								<picture>
									<img
										[src]="panel.targetImage"
										[attr.alt]="panel.name"
										width="50"
										height="50"
										loading="lazy" />
								</picture>
							</div>
							<!-- For LCP purpose when is mobile we will prioritize the first 3 images only. That is why "i" has an addition of 2 -->
							<shared-media-component-media
								*ngIf="panel.fullImage || panel.visualAssets"
								[visualAssets]="panel.visualAssets"
								[image]="panel.fullImage"
								[itemTitle]="panel.note ? panel.note : panel.name"
								[altText]="''"
								[willLazyLoad]="true"
								[imagePagePosition]="i+mobileImageAddition">
							</shared-media-component-media>
						</span>
						<strong *ngIf="panel.note"> {{ panel.note }}</strong>
						<strong *ngIf="!panel.note"> {{ panel.name }}</strong>
					</a>
				</div>
			</div>
		</ng-template>
		<ng-template #largeAccordian>
			<div
				class="cats"
				[ngClass]="{
					'overflow-category': categoryData.childVOs && categoryData.childVOs.length > 9
				}"
				(scroll)="hideCategory($event)">
				<div
					*ngFor="let panel of categoryData.childVOs; index as i; trackBy: trackByFn"
					[ngClass]="{ family: panel.pageType !== 'c' }">
					<mat-expansion-panel
						#mep="matExpansionPanel"
						[expanded]="panel.panelOpenState"
						(opened)="panel.panelOpenState = true"
						(closed)="panel.panelOpenState = false"
						*ngIf="panel.pageType === 'c'"
						(mouseleave)="panel.panelOpenState = false; hideAllSubCategories()"
						[@.disabled]="true">
						<mat-expansion-panel-header
							(click)="categoryClick($event, i)"
							(mouseenter)="categoryClick($event, i)">
							<mat-panel-title
								attr.data-em="{{ panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′' }}"
								[attr.title]="panel.note ? panel.note : panel.name">
								<span>
									<!-- For LCP purpose when is desktop we will prioritize the first 7 images only. That is why 1 and 5 -->
									<shared-media-component-media
										*ngIf="panel.fullImage || panel.visualAssets"
										[visualAssets]="panel.visualAssets"
										[image]="panel.fullImage"
										[itemTitle]="panel.note ? panel.note : panel.name"
										[altText]="''"
										[willLazyLoad]="true"
										[imagePagePosition]="i <= maxDesktopImage ? eagerImagePosition : lazyImagePosition">
									</shared-media-component-media>
								</span>
								<strong *ngIf="panel.note"> {{ panel.note }}</strong>
								<strong *ngIf="!panel.note"> {{ panel.name }}</strong>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div
								*ngIf="panel.childVOs"
								class="row accordian-data"
								(scroll)="hideCategory($event)">
								<div
									*ngFor="let cat of panel.childVOs; trackBy: trackByFn"
									class="col-4 col-md-2 col-lg-3 col-xl-2">
									<a
										[href]="cat.url"
										[attr.data-em]="
											cat.em | dcsgStripSpecialChars: '\ |\&|\'|\′'
										"
										[attr.title]="cat.note ? cat.note : cat.name">
										<span>
											<!-- For LCP purposes: Images are forced to be lazy loaded (imagePagePosition=5)
												because they're located inside the expansion panel, and they are not needed in the initial viewport -->
											<shared-media-component-media
												*ngIf="cat.fullImage || cat.visualAssets"
												[visualAssets]="cat.visualAssets"
												[image]="cat.fullImage"
												[itemTitle]="cat.note ? cat.note : cat.name"
												[altText]="''"
												[willLazyLoad]="true"
												[imagePagePosition]="lazyImagePosition">
											</shared-media-component-media>
										</span>
										<p *ngIf="cat.note">{{ cat.note }}</p>
										<p *ngIf="!cat.note">{{ cat.name }}</p>
									</a>
								</div>
							</div>
							<div
								*ngIf="panel.childVOs"
								class="view-all-container row">
								<div class="col-6">
									<a
										[href]="panel.url"
										attr.data-em="{{
											panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′'
										}}_ViewAllCategories"
										[attr.title]="panel.note ? panel.note : panel.name"
										>View Category Page</a
									>
								</div>
								<div
									class="col-6"
									(click)="
										mep.expanded = !mep.expanded; panel.panelOpenState = false
									">
									<span>Close</span>
									<homefield-icon name="chevron-up"></homefield-icon>
								</div>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<a
						[href]="panel.url"
						class="category-link"
						*ngIf="panel.pageType !== 'c'"
						[attr.data-em]="panel.em | dcsgStripSpecialChars: '\ |\&|\'|\′'"
						[attr.title]="panel.note ? panel.note : panel.name">
						<span>
							<div
								*ngIf="panel.targetImage"
								class="image-box">
								<picture>
									<img
										[src]="panel.targetImage"
										[attr.alt]="panel.name"
										width="56"
										height="56"
										loading="lazy" />
								</picture>
							</div>
							<!-- For LCP purpose when is desktop we will prioritize the first 7 images only. That is why 1 and 5 -->
							<shared-media-component-media
								*ngIf="panel.fullImage || panel.visualAssets"
								[visualAssets]="panel.visualAssets"
								[image]="panel.fullImage"
								[itemTitle]="panel.note ? panel.note : panel.name"
								[altText]="panel.note || panel.name"
								[willLazyLoad]="true"
								[imagePagePosition]="i <= maxDesktopImage ? eagerImagePosition : lazyImagePosition">
							</shared-media-component-media>
						</span>
						<strong *ngIf="panel.name; else showPanelNote"> {{ panel.name }}</strong>
						<ng-template #showPanelNote> {{ panel.note }} </ng-template>
					</a>
				</div>
			</div>
		</ng-template>
	</div>
</div>
